import { styled, Grid, Card } from "@mui/material";

export const CardWrapper = styled(Grid)({
  padding: "5px",
});

export const CardContainer = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: "flex",
  justifyContent: "space-between",
  gap: "10px",
  borderRadius: "3px",
  position: "relative",
  "& .template-delete-button": {
    opacity: 0,
    position: "absolute",
    top: "0px",
    left: "50%",
  },
  "&:hover": {
    "& .template-delete-button": {
      opacity: 1,
    },
  },
}));

export const LegislationContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px",
});
export const NameDescriptionContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});
export const HistoryContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px",
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.primary.main,
  "&>.MuiGrid-root": {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
  },
}));
export const GenerateDocumentContainer = styled(Grid)(({ theme }) => ({
  position: "relative",
  color: theme.palette.primary.main,
  padding: "10px",
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
}));

export const DownloadContainer = styled(Grid)(({ theme }) => ({
  color: theme.palette.primary.main,
  padding: "10px",
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));
